import React from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ProgressItem {
  text: string;
  completed: boolean;
}

interface ProgressListProps {
  items: ProgressItem[];
}

export const ProgressList = ({ items }: ProgressListProps): JSX.Element => (
    <div className='mb-10 p-6 text-sm font-light flex xl:items-center flex-col xl:flex-row'>
      {items.map((item, index) => (
        <React.Fragment key={item.text}>
            <div className='flex flex-row xl:flex-col relative'>
              <div className={`flex items-center min-w-[24px] min-h-[24px] w-6 h-6 rounded-full justify-center text-white ${item.completed ? 'bg-emerald' : 'bg-gray-400'}`}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <span className='ml-2 xl:ml-0 xl:mt-8 xl:absolute xl:left-1/2 xl:transform xl:-translate-x-1/2 truncate'>{item.text}</span>
            </div>
            {index < items.length - 1 && (
              <div className={`ml-2.5 w-1 h-4 xl:ml-0 xl:flex-grow xl:h-1 ${item.completed ? 'bg-emerald' : 'bg-gray-400'}`} />
            )}
        </React.Fragment>
      ))}
    </div>
  );
